import { render, staticRenderFns } from "./AppTableHeaderSelect.vue?vue&type=template&id=1b952ff3"
import script from "./AppTableHeaderSelect.vue?vue&type=script&lang=js"
export * from "./AppTableHeaderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports